<template>
  <div class="logisticsLink">
    <div class="table-box">
      <el-table
        :data="tableList"
        max-height="440"
        :header-cell-style="{background:'#FAFAFA'}"
        style="border: 1px solid #E1E1E6;"
      >
        <el-table-column align="center" label="物流名称">
          <template slot-scope="scope">{{scope.row.title}}</template>
        </el-table-column>
        <el-table-column align="center" label="最后修改时间" width="240px;">
          <template slot-scope="scope">{{scope.row.updateTime}}</template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-radio
              @change="linkChange"
              v-model="logisticsLinkTag"
              :label="scope.row.logisticsLinkTag"
            >{{scope.row.logisticsLinkTag==logisticsLinkTag?'正在使用':'使用'}}
            </el-radio>
            <!-- <el-button type="primary" size="small" @click="useLink(scope.row)">使用</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page" style="margin-top:30px;;height:10px;">
      <el-pagination
        style="float:right"
        background
        layout="prev, pager, next"
        :page-size="pageInfo.pageSize"
        :total="total"
        :current-page="pageInfo.pageNum"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getLogisticsAdvertiseConfigList } from "@/api/care/logisticsAdvertise";
export default {
  data() {
    return {
      tableList: [],
      logisticsLinkTag: "",
      linkDialog: true,
      total: 20,
      pageInfo: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  created() {
    this._getLogisticsAdvertiseConfigList();
   
  },
  methods: {
    linkChange(v) {
      this.$emit("logiLinkFn", v);
    },
    handleCurrentChange(v) {
     this.pageInfo.pageNum=v
      this._getLogisticsAdvertiseConfigList()
    },
    //获取物流广告信息
    _getLogisticsAdvertiseConfigList() {
      let params = { ...this.pageInfo };
      getLogisticsAdvertiseConfigList(params)
        .then(res => {
          if (res.code == 200) {
            this.tableList = res.data.dataList;
            this.total = res.data.pageInfo.total;
            let text = this.$parent.$parent.postForm.content;
            //编辑回显
            for (let i = 0; i < this.tableList.length; i++) {
              if (text.search(this.tableList[i].logisticsLinkTag) != -1) {
                this.logisticsLinkTag = this.tableList[i].logisticsLinkTag;
                this.$parent.$parent.lastInsertLink=this.tableList[i].logisticsLinkTag;
              } else {
                //this.getInputFilterList.splice(i, 1);
              }
            }
          }
        })
        .catch(e => {});
    },
    handleDialogClose() {
      //this.$$parent.logiState = false;
      //this.linkDialog = false;
      //this.$emit('logiLinkFn',false)
    }
  }
};
</script>
<style lang="sass" scoped>

</style>
